import { render, staticRenderFns } from "./Receiving.vue?vue&type=template&id=9a9b39ac&scoped=true"
import script from "./Receiving.vue?vue&type=script&lang=js"
export * from "./Receiving.vue?vue&type=script&lang=js"
import style0 from "./Receiving.vue?vue&type=style&index=0&id=9a9b39ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9b39ac",
  null
  
)

export default component.exports